import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface AboutSection {
  id: number;
  title: string;
  body: string;
  mediaAssetId: number | null;
  sortOrder: number;
}

@Injectable({
  providedIn: 'root'
})
export class AboutService {
  constructor(private readonly http: HttpClient) {}

  getSections(): Observable<AboutSection[]> {
    return this.http.get<AboutSection[]>(
      `${environment.apiUrl}/about`
    );
  }

  getMediaUrl(mediaAssetId: number | null): string | null {
    return mediaAssetId
      ? `${environment.apiUrl}/media/${mediaAssetId}`
      : null;
  }
}